import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading) {
            if (user) {
                // Redirect based on role
                if (user.role === 'admin') {
                    navigate('/admin');
                } else if (user.role === 'manager') {
                    navigate('/manager');
                } else {
                    navigate('/dashboard');
                }
            } else {
                // If no user after loading, go to login
                navigate('/');
            }
        }
    }, [user, loading, navigate]);

    return (
        <div className="min-h-screen mafia-gradient flex flex-col items-center justify-center text-white p-4">
            <div className="text-center space-y-4 animate-fade-in">
                <Loader2 className="w-12 h-12 mx-auto animate-spin gold-text" />
                <h2 className="text-2xl font-display font-bold gold-text">In contatto con la Famiglia...</h2>
                <p className="text-zinc-400">Pazienta un istante, il Don sta verificando le tue credenziali. 🤌</p>
            </div>
        </div>
    );
};

export default AuthCallback;
